module.exports = __webpack_public_path__ + "static/bluebox-step-bf1fc5c0bb6c2f9ba64f34b7cf10a7d7.png";